import { Component, Inject, forwardRef } from '@angular/core';
import { AppComponent } from '../../app.component';

import { UserService } from '@app/core';
import { DefaultOrg, RouteLink } from '@app/shared';

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.css']
})
export class AppFooterComponent {

  DefaultOrg: typeof DefaultOrg = DefaultOrg;
  RouteLink: typeof RouteLink = RouteLink;



  constructor (@Inject(forwardRef(() => AppComponent)) public app: AppComponent, public user: UserService) { }

  initiateSupport() {
    console.log("Sdf");
    this.app.showSupport = true;
  }

}
